
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M6 41.19v-24l12 2.5v15.5z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M8 38.19v-24l12 2.5v15.5z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M24 9v30"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M42 41.19v-24l-12 2.5v15.5z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M40 38.19v-24l-12 2.5v15.5z"}})])
          )
        }
      }
    